export const defaultState = () => ({
  providerId: null,
  errors: {},
  errorsMessage: '',
  loading: false,
  presetSettigns: [],
  isOurPanel: false,
  formData: {
    name: '',
    endpoint: '',
    apiToken: '',
    currency: '',
    syncServices: false,
    syncPackages: false,
    syncPrices: false,
    syncName: false,
    syncMeta: false,
    syncServiceDetails: false,
    syncDescriptionField: '',
    syncParams: false,
    syncLabels: false,
    resaleMarginPercent: '',
    isArchived: false,
    autoRecreateOrdersIsAllowed: false,
  },
  providers: [],
});

export default () => ({
  isShown: false,
  saving: false,
  success: false,
  ...defaultState(),
});
